import { useEffect, useState } from 'react';
import { BitArray } from '../models/cmd/BitArray';
import { ByteArray } from '../models/cmd/ByteArray';

export const getFavIdxByHostID = (hostID: number) => {
    for (let i = 0; i < FavTableIndex.MAX; i++) {
        if (getHostIDByFavIdx(i) == hostID) {
            return i;
        }
    }
    return -1;
};
export const getHostIDByFavIdx = (idx: number) => {
    const table = <string>FavTableIndex[idx];
    const tmp = table.split('_');
    if (tmp.length > 1) return Number(tmp[1]);
    return 0;
};
export const updateFavoriteBit = (FPlayerPrefs3: string, hostID: number) => {
    const idx = getFavIdxByHostID(hostID);
    const value = BigInt(FPlayerPrefs3);
    const ba: ByteArray = new ByteArray();
    ba.writeUint64(value);
    ba.position = 0;
    const bitArr = new BitArray(ba);
    let binaryStr = '';
    for (let i = 0; i < 64; i++) {
        if (bitArr.readBoolean()) {
            if (idx == i) {
                binaryStr = '0' + binaryStr;
            } else {
                binaryStr = '1' + binaryStr;
            }
        } else {
            if (idx == i) {
                binaryStr = '1' + binaryStr;
            } else {
                binaryStr = '0' + binaryStr;
            }
        }
    }
    const bigInt = BigInt('0b' + binaryStr);
    return bigInt.toString();
};
export const useFavorite = (FPlayerPrefs3: string) => {
    const [favoriteTableList, setFavoriteTableList] = useState<Array<number>>(
        []
    );

    useEffect(() => {
        if (FPlayerPrefs3) {
            const value = BigInt(FPlayerPrefs3);
            const ba: ByteArray = new ByteArray();
            ba.writeUint64(value);
            ba.position = 0;
            const bitArr = new BitArray(ba);
            bitArr.position = 0;
            let list = [];
            for (let i = 0; i < FavTableIndex.MAX; i++) {
                if (bitArr.readBoolean()) {
                    list.push(getHostIDByFavIdx(i));
                }
            }
            setFavoriteTableList(list);
        }
    }, [FPlayerPrefs3]);

    return favoriteTableList;
};

export const doRecycleIndex = (FPlayerPrefs3: string) => {
    const value = BigInt(FPlayerPrefs3);
    const ba: ByteArray = new ByteArray();
    ba.writeUint64(value);
    ba.position = 0;
    const bitArr = new BitArray(ba);
    let binaryStr = '';
    for (let i = 0; i < 64; i++) {
        if (bitArr.readBoolean()) {
            if (isRecycleIndex(i)) {
                binaryStr = '0' + binaryStr;
            } else {
                binaryStr = '1' + binaryStr;
            }
        } else {
            binaryStr = '0' + binaryStr;
        }
    }
    const bigInt = BigInt('0b' + binaryStr);
    return bigInt.toString();
};

export const isRecycleIndex = (index: number): boolean => {
    switch (index) {
        case FavTableIndex.X_BACC_618:
        case FavTableIndex.X_SICBO_821:
        case FavTableIndex.X_BACC_854:
        case FavTableIndex.X_BACC_855:
        case FavTableIndex.X_BACC_856:
        case FavTableIndex.X_BACC_857:
        case FavTableIndex.X_BACC_858:
        case FavTableIndex.X_ROUL_830:
        case FavTableIndex.X_DT_850:
        case FavTableIndex.X_DT_820:
        case FavTableIndex.X_BACC_831:
        case FavTableIndex.X_BACC_832:
        case FavTableIndex.X_BACC_833:
        case FavTableIndex.X_BACC_834:
        case FavTableIndex.X_BACC_835:
        case FavTableIndex.X_TP_221:
            return true;
    }
    return false;
};

export enum FavTableIndex {
    BACC_521,
    BACC_522,
    BACC_523,
    BACC_524,
    BACC_909,
    UROUL_928,
    BACC_871,
    UROUL_862,
    UROUL_541,
    BACC_872,
    BACC_873,
    BACC_874,
    BACC_875,
    BACC_876,
    BACC_877,
    BACC_878,
    ROUL_861,
    X_BACC_618,
    BACC_836,
    BACC_837,
    BACC_838,
    BACC_901,
    BACC_902,
    BACC_903,
    BACC_904,
    X_SICBO_821,
    BACC_905,
    BACC_906,
    BACC_907,
    BACC_908,
    SEDIE_531,
    SICBO_532,
    ROUL_533,
    DT_534,
    POKDENG_535,
    BJ_536,
    AB_537,
    TP_538,
    BJ_921,
    DT_922,
    POKDENG_923,
    ROUL_924,
    SICBO_925,
    HILO_926,
    SEDIE_927,
    X_TP_221,
    CT_222,
    BJ2_929,
    BJ2_542,
    HILO_539,
    FPC_540,
    X_BACC_854,
    X_BACC_855,
    X_BACC_856,
    X_BACC_857,
    X_BACC_858,
    X_BACC_831,
    X_BACC_832,
    X_BACC_833,
    X_BACC_834,
    X_BACC_835,
    X_ROUL_830,
    X_DT_850,
    X_DT_820,
    MAX,
}
